import { forwardRef, Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeCanActivate } from 'app/core/guards/dependency-tree.guard';
import { logger } from 'app/core/util/logger';
import { Observable, of } from 'rxjs';
import * as fromRoot from '..';
import { RootState } from '../index';
import { TemplatesLoadAction } from './template.actions';
import { TemplateState } from './template.interface';
import { filter, first, switchMap } from 'rxjs/operators';

/**
 * Guard to async load the templates before following a route
 */
@Injectable({ providedIn: 'root' })
export class GetOrderTemplatesGuard implements CanActivate, DependencyTreeCanActivate {
  private store: Store<fromRoot.RootState>;

  constructor(@Inject(forwardRef(() => Store)) store) {
    this.store = store;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    logger.debug(`In GetOrderTemplatesGuard`);

    return this.store.pipe(
      filter((root: fromRoot.RootState) => root.session.userContext.contextLoaded),
      first(),
      switchMap((root: RootState) => {
        if (root.session.authorization.data.ORDER.QUERY_TEMPLATE) {
          this.store.dispatch(new TemplatesLoadAction({ type: 'ORDER' }));
          return this.store.select('template').pipe(
            filter((template: TemplateState) => template.loadSuccess),
            first(),
            switchMap(() => {
              return of(true);
            })
          );
        } else {
          return of(true);
        }
      })
    );
  }

  getDependencies(): any {
    return [CustomerInfoLoadIfNormalUserGuard];
  }

  getDependencyRouteData(): any {}
}
